export default __webpack_public_path__ + "static/media/uir-new-small.fc1eba5e.png";